import {
  INotification,
  IUserSpecifications,
} from "services/configuration/notifications/types";

interface INotificationGrouped {
  [key: number]: {
    domain: string;
    domainId: number;
    notifications: INotification[];
  };
}

export const userSpecificationQueryToForm = (
  userSpecifications: IUserSpecifications[]
): INotificationGrouped => {
  return userSpecifications.reduce<INotificationGrouped>((acc, spec) => {
    const { contentCategoryId, notificationTypeId, sendEmail } =
      spec.specification;

    if (!acc[contentCategoryId]) {
      acc[contentCategoryId] = {
        domain: `Domain${contentCategoryId}`,
        domainId: contentCategoryId,
        notifications: [],
      };
    }

    acc[contentCategoryId].notifications.push({
      id: notificationTypeId,
      contentCategoryId,
      actionTypeId: notificationTypeId,
      isSelected: spec.enabled,
      sendEmail,
    });

    return acc;
  }, {});
};
